import "./TermsAndConditionsModal.less";
import "simplebar/dist/simplebar.css";

import * as React from "react";
import { translate } from "react-i18next";
import SimpleBar from "simplebar-react";
import classnames from "classnames";
import { Waypoint } from "react-waypoint";
import $ from "jquery";

import Checkbox from "../../inputs/Checkbox/Checkbox";
import RadioButton from "../../inputs/RadioButton/RadioButton";
import LoadingButton from "../../inputs/LoadingButton/LoadingButton";
import { scrollIntoView } from "../../../utils/ScrollIntoView";

const AgeRestriction = {
	OLDER: "older",
	YOUNGER: "younger",
	NONE: "none"
}

class TermsAndConditionsModal extends React.Component {
	sectionStates = {};
	sectionRefs = {};

	state = {
		ageRestriction: AgeRestriction.NONE,
		consentContact: false,
		activeSectionId: "champ",
		showLoading: false
	};

	componentDidMount() {
		$("#termsmodal").on("shown.bs.modal", () => {
			const element = document.getElementById("champ");
			element.scrollIntoView({ block: 'start' });
		});
	}

	render() {
		const { t, noInputs } = this.props;
		const { activeSectionId, showLoading } = this.state;

		return (
			<div className="modal fade" id="termsmodal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="terms-and-conditions">
							<div className="header">
								<p className="title">{t("modalTitle")}</p>
							</div>
							<div className="terms-container">
								<div className="row">
									<div className="col-md-4">
										<div className="tableofcontents">
											<ul>
												{TERMS.map((term, index) => (
													<li key={term.id} itemRef={`#${term.id}`} onClick={this.handleShow.bind(this, term.id)}
														className={classnames({ active: term.id === activeSectionId })}>
														{`${index + 1}. ${t(term.titleKey)}`}
													</li>
												))}
											</ul>
										</div>
									</div>
									<div className="col-md-8">
										<div className="termstext">
											<SimpleBar style={{ paddingRight: "15px" }}>
												{TERMS.map(term => (
													<Waypoint key={term.id} onPositionChange={this.handlePositionChange(term.id)}>
														<div key={term.id} id={term.id} ref={this.createSectionRef(term)} dangerouslySetInnerHTML={{ __html: t(term.textKey) }} />
													</Waypoint>
												))}
											</SimpleBar>
										</div>
									</div>
								</div>
							</div>
							{
								noInputs ? null : (
									<React.Fragment>
										<div className="body">
											<RadioButton id="older-input" name="age" value={AgeRestriction.OLDER} onClick={this.handleRadioButtonClick} checked={this.state.ageRestriction === AgeRestriction.OLDER}>
												<div className="input-label">
													<strong>{t("olderTitle")}</strong> {t("olderContent")}
												</div>
											</RadioButton>
											<RadioButton id="younger-input" name="age" value={AgeRestriction.YOUNGER} onClick={this.handleRadioButtonClick} checked={this.state.ageRestriction === AgeRestriction.YOUNGER}>
												<div className="input-label">
													<strong>{t("youngerTitle")}</strong> {t("youngerContent")}
												</div>
											</RadioButton>
											<Checkbox id="contact-input" name="contact" onClick={this.handleConsentContact} checked={this.state.consentContact}>
												<div className="input-label">
													{t("consent")}
												</div>
											</Checkbox>
										</div>
										<div className="footer">
											<LoadingButton label={t("submitButtonLabel")}
												className="okay-button"
												disabled={!this.isValid()}
												onClick={this.submit}
												showLoading={showLoading}
											/>
										</div>
									</React.Fragment>
								)
							}
						</div>
					</div>
				</div>
			</div>
		);
	}

	handlePositionChange = (idx) => {
		return (args) => {
			this.sectionStates[idx] = args.currentPosition;

			const currentSection = Object.entries(this.sectionStates).find((entry) => entry[1] === Waypoint.inside);

			const termsId = currentSection ? currentSection[0] : "champ";

			if (termsId !== this.state.activeSectionId) {
				this.setState({ activeSectionId: termsId });
			}
		};
	};

	createSectionRef = (term) => {
		return (instance) => {
			this.sectionRefs[term.id] = instance;
		};
	};

	handleShow = (id) => {
		if (id !== undefined) {
			scrollIntoView(this.sectionRefs[id]);
		}
	};

	handleRadioButtonClick = (event) => {
		this.setState({ ageRestriction: event.target.value });
	};

	handleConsentContact = () => {
		this.setState({ consentContact: !this.state.consentContact });
	};

	isValid = () => {
		return this.state.ageRestriction !== AgeRestriction.NONE;
	};

	getIsUnder16 = () => {
		return this.state.ageRestriction === AgeRestriction.YOUNGER;
	};

	submit = () => {
		// TODO: implement the submit, set showLoading state property if needed
		// this.getIsUnder16(), this.state.consentContact
	};
}

export default translate("terms")(TermsAndConditionsModal);

const TERMS = [
	{ id: "champ", titleKey: "champ.title", textKey: "champ.text" },
	{ id: "sit_web", titleKey: "sitWeb.title", textKey: "sitWeb.text" },
	{ id: "compte", titleKey: "compte.title", textKey: "compte.text" },
	{ id: "utilisation", titleKey: "utilisation.title", textKey: "utilisation.text" },
	{ id: "licences", titleKey: "licences.title", textKey: "licences.text" },
	{ id: "vie", titleKey: "vie.title", textKey: "vie.text" },
	{ id: "politique", titleKey: "politique.title", textKey: "politique.text" },
	{ id: "droits", titleKey: "droits.title", textKey: "droits.text" },
	{ id: "contenu", titleKey: "contenu.title", textKey: "contenu.text" },
	{ id: "responsabilité", titleKey: "responsabilité.title", textKey: "responsabilité.text" },
	{ id: "divers", titleKey: "divers.title", textKey: "divers.text" }
];



// WEBPACK FOOTER //
// ./src/components/Modals/TermsAndConditionsModal/TermsAndConditionsModal.js